import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/garcom/comanda/$id')({
  validateSearch: (search: Record<string, unknown>) => ({
    tab:
      search.tab === 'cart'
        ? ('cart' as const)
        : search.tab === 'bill'
          ? ('bill' as const)
          : ('menu' as const),
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/comanda/$id',
      params,
      search,
    })
  },
})
